import { render } from "./MarketPlaceApp.vue?vue&type=template&id=65764021&scoped=true"
import script from "./MarketPlaceApp.vue?vue&type=script&lang=js"
export * from "./MarketPlaceApp.vue?vue&type=script&lang=js"

import "./MarketPlaceApp.vue?vue&type=style&index=0&id=65764021&scoped=true&lang=css"
import "./MarketPlaceApp.vue?vue&type=style&index=1&id=65764021&lang=css"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65764021"]])

export default __exports__